import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { LoadingIcon } from '@/components/icons/loading'
import { useMixpanel } from '@/context/mixpanel'
import { useTxSubmissionBlocked } from '../txPanel/txSubmissionGuard'

interface CrosschainSignPermitProps {
  disabled?: boolean
  loading: boolean
  error?: Error | null
  onClick: () => void
  currentStep?: number
  totalSteps?: number
}

export const CrosschainSignPermit = ({
  disabled,
  loading,
  error,
  onClick,
  currentStep = 0,
  totalSteps = 1,
}: CrosschainSignPermitProps) => {
  const { trackEvent } = useMixpanel()
  const submissionBlocked = useTxSubmissionBlocked()

  const getButtonLabel = () => {
    if (totalSteps === 1) {
      return 'Sign cross-chain transaction'
    }

    if (currentStep === 0) {
      return `1/${totalSteps} Sign preparation transaction`
    }

    return `${totalSteps}/${totalSteps} Sign cross-chain transaction`
  }

  return (
    <div className="flex flex-col gap-2">
      {error && (
        <Note color="red" className="break-words">
          <p className="inline-block first-letter:uppercase">{error.message || 'An error occurred'}</p>
        </Note>
      )}
      <Button
        type="button"
        size="sm"
        className="gap-2"
        disabled={disabled || loading || submissionBlocked}
        onClick={() => {
          trackEvent('Opportunity widget action clicked', { Action: 'crosschain-deposit' })
          onClick()
        }}
      >
        {loading && <LoadingIcon size={16} className="animate-spin" />}
        {getButtonLabel()}
      </Button>
    </div>
  )
}
